import { render, staticRenderFns } from "./HyfxBlock.vue?vue&type=template&id=1531b0e8&scoped=true"
import script from "./HyfxBlock.vue?vue&type=script&lang=js"
export * from "./HyfxBlock.vue?vue&type=script&lang=js"
import style0 from "./HyfxBlock.vue?vue&type=style&index=0&id=1531b0e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1531b0e8",
  null
  
)

export default component.exports